export function isPromiseLike(value: unknown): value is PromiseLike<unknown> {
	return !!value && typeof (value as PromiseLike<unknown>).then === "function"
}

export async function awaitMaybePromise(value: unknown): Promise<void> {
	if (isPromiseLike(value)) {
		await value
	}
}
